'use strict'
import AclPlugin from './aclPlugin'

/**
 * Adaptado do Vue ACl
 *
 * @link https://github.com/leonardovilarinho/vue-acl
 */

let mixin = {
  props: {
    'roles': {
      default: function () {
        return Laravel.roles
      },
    },
    'permissions': {
      default: function () {
        return Laravel.permissions
      },
    },
  },
  /*data() {
    return {roles: ''}
  },*/
  mounted () {
    //this.roles = this.clearRoles(this.roles);
  },
  methods: {
    hasRole (role, userId) {
      if (role == undefined)
        return false

      if (userId != undefined) {
        if (userId != Laravel.userId) return false
      }

      const roles = (role.indexOf('|') !== -1) ? role.split('|') : [role]
      return this.findRole(roles) !== undefined
    },

    findRole (list) {
      return list.find((role) => {
        const needed = (role.indexOf('&') !== -1) ? role.split('&') : role
        if (Array.isArray(needed))
          return needed.every(need => (this.roles.indexOf(need) !== -1))

        return this.roles.indexOf(needed) !== -1
      })
    },
    clearRoles (roles) {
      if (roles == undefined) {
        return []
      }
      if (roles.indexOf('&') !== -1)
        roles = roles.split('&')

      return Array.isArray(roles) ? roles : [roles]
    },
  },
}

// pode ser substituido por implementacão de LocalStorage
const AclStorage = function () {
  return {
    getPermissions: function () {
      return Laravel.permissions
    },
    getRoles: function () {
      return Laravel.roles
    },
    getUser () {
      return Laravel.userId
    },
  }
}

const Acl = {
  install (Vue, options) {
    let storage = AclStorage()
    var plugin = new AclPlugin(storage)

    Vue.mixin(mixin)

    Vue.prototype.$hasRole = plugin.hasRole
    Vue.prototype.$hasPermission = plugin.hasPermission
    Vue.prototype.$can = plugin.hasPermission
  },
}

export default Acl


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/acl.js